import React from "react";
import { SlideService } from "../../components/servicesListe/slideSerice";
import img from "../../assets/images/dev.png";
import ServicesSection from "../../components/servicesListe/servicesSection";
import { DéveloppementIcon } from "../../assets/icons/DéveloppementIcon";
import { WebIcon } from "../../assets/icons/WebIcon";
import { MobileIcon } from "../../assets/icons/MobileIcon";

const services = [
  {
    title: "Développement",
    description:
      "Des plateformes performantes, adaptées à vos besoins et pensées pour évoluer",
    icon: <DéveloppementIcon />,
    variant: "white",
  },
  {
    title: "Développement Web",
    description: "Sites vitrines, e-commerce, plateformes personnalisées",
    icon: <WebIcon />,
    variant: "green",
  },

  {
    title: "Application Mobile",
    description: "iOS, Android, hybrides",
    icon: <MobileIcon />,
    variant: "green",
  },
  {
    title: "CRM",
    description:
      "Un outil stratégique pour gérer et renforcer les relations clients, centraliser les données et optimiser les performances commerciales",
    icon: <MobileIcon />,
    variant: "white",
  },
  {
    title: "ERP",
    description: "Systèmes de gestion intégrée adaptés à vos processus",
    icon: <MobileIcon />,
    variant: "white",
  },
];
export const DevPage = () => {
  return (
    <div>
      <SlideService
        title={"Développement Web"}
        description={
          "Des plateformes performantes, adaptées à vos besoins et pensées pour évoluer"
        }
        img={img}
      />

      <ServicesSection services={services} />
    </div>
  );
};
